import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { DocumentStatus, GetEnumValuesDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { DialogService } from '../../../../core/services/dialog.service';
import { FileService } from '../../../../core/services/file.service';

@Component({
    selector: 'app-base-documentations',
    template: ``,
    standalone: false
})
export class BaseDocumentationsComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  imgUrl: any;
  pdfUrl: any;

  @Input() modelItems: any[] = [];
  @Input() counter: number;
  @Input('documentStatusEnumValues')
  DocumentStatusEnumValues: GetEnumValuesDto[] = [];
  @Input() blob: any;
  @Input() documentTypes: GetEnumValuesDto[];

  get DocumentStatus() {
    return DocumentStatus;
  }

  //#endregion

  constructor(
    protected dialogService: DialogService,
    protected translate: TranslateService,
    protected fileService: FileService,
    protected domSanitizer: DomSanitizer
  ) {
    super();
  }

  initForm(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    try {
      this.loading = true;
      //get document file
      this.blob = changes['blob']?.currentValue;
      if (this.blob) {
        if (this.blob.type == 'application/pdf') {
          this.pdfUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
            URL.createObjectURL(this.blob)
          );
          this.imgUrl = null;
        } else {
          this.getBase64(this.blob).then((data) => {
            this.imgUrl = data;
          });
          // this.imgUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
          //   'data:image/jpg;base64,' + this.blob?.data?.fileContents
          // );
          this.pdfUrl = null;
        }
      } else {
        this.imgUrl = null;
      }
      this.loading = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
}
